export default "__VITE_PUBLIC_ASSET__39383411__"